<template>
  <div class="page-wrap" id="scratchCard-page" :style="{ backgroundImage : 'url(' + activeObj.pageBgc + ')'}">
    <div class="scratchCard-box">
      <div class="award-box" v-if="showPrize">
          <span>198元优惠券</span>
      </div>
      <canvas id="c1" class="canvas" @touchmove="touchmove" @touchstart="touchstart" @touchend="touchend" v-show="!isScratch"></canvas>
    </div>
  </div>
</template>

<script>
export default {
  name: "scratchCard",
  data() {
    return {
      activeObj: {
        pageBgc: "/images/scratchCard-page-bg.png",
        prizeData: [
          {
            id: 1,
            prize: "88元",
          },
          {
            id: 2,
            prize: "20元",
          },
          {
            id: 3,
            prize: "100金币",
          },
          {
            id: 4,
            prize: "20元",
          },
          {
            id: 5,
            prize: "谢谢参与",
          },
          {
            id: 6,
            prize: "20元",
          },
          {
            id: 7,
            prize: "200元",
          },
          {
            id: 8,
            prize: "谢谢参与",
          },
        ],
      },
      c1: "", //画布
      ctx: "", //画笔
      ismousedown: false, //标志用户是否按下鼠标或开始触摸
      fontem: "", // 获取html字体大小
      isScratch: false, // 是否刮过卡
      showPrize: false, // 显示奖品
    };
  },
  mounted() {

    //获取html的字体大小
    this.fontem = parseInt(window.getComputedStyle(document.documentElement, null)["font-size"]);

    //这是为了不同分辨率上配合@media自动调节刮的宽度
    this.c1 = document.getElementById("c1");

    //这里很关键，canvas自带两个属性width、height,我理解为画布的分辨率，跟style中的width、height意义不同。
    //最好设置成跟画布在页面中的实际大小一样
    //不然canvas中的坐标跟鼠标的坐标无法匹配
    this.c1.width = this.c1.clientWidth;
    this.c1.height = this.c1.clientHeight;
    this.ctx = this.c1.getContext("2d");
    
    this.initCanvas();
  },
  methods: {
    // 画刮刮卡
    initCanvas() {
      this.ctx.globalCompositeOperation = "source-over";
      this.ctx.fillStyle = "#e5e5e5";
      this.ctx.fillRect(0, 0, this.c1.clientWidth, this.c1.clientHeight);
      this.ctx.fill();
      this.ctx.font = "Bold 18px Arial";
      this.ctx.textAlign = "center";
      this.ctx.fillStyle = "#a0a0a0";
      this.ctx.fillText("刮开有奖", this.c1.width / 2, 55);
      //有些老的手机自带浏览器不支持destination-out,下面的代码中有修复的方法
      this.ctx.globalCompositeOperation = "destination-out";
    },
    //开始刮卡
    touchstart(e) {
      e.preventDefault();
      this.ismousedown = true;
    },
    // 操作刮卡
    touchend(e) {
      sessionStorage.setItem("isScratch", true);
      e.preventDefault();
      //得到canvas的全部数据
      var a = this.ctx.getImageData(0, 0, this.c1.width, this.c1.height);
      var j = 0;
      for (var i = 3; i < a.data.length; i += 4) {
        if (a.data[i] == 0) j++;
      }
      //当被刮开的区域等于一半时，则可以开始处理结果
      if (j >= a.data.length / 8) {
        this.isScratch = true;
      }
      this.ismousedown = false;
    },
    touchmove(e) {
      this.showPrize = true;
      e.preventDefault();
      if (this.ismousedown) {
        if (e.changedTouches) {
          e = e.changedTouches[e.changedTouches.length - 1];
        }
        var topY = document.getElementById("scratchCard-page").offsetTop;
        var oX = this.c1.offsetLeft;
        var oY = this.c1.offsetTop + topY;
        var x = (e.clientX + document.body.scrollLeft || e.pageX) - oX || 0;
        var y = (e.clientY + document.body.scrollTop || e.pageY) - oY || 0;
        //画360度的弧线，就是一个圆，因为设置了ctx.globalCompositeOperation = 'destination-out';
        //画出来是透明的
        this.ctx.beginPath();
        this.ctx.arc(x, y, 16 * 0.5, 0, Math.PI * 2, true); // 调整画笔的大小
        //下面3行代码是为了修复部分手机浏览器不支持destination-out
        //我也不是很清楚这样做的原理是什么
        // this.c1.style.display = 'none';
        // this.c1.offsetHeight;
        // this.c1.style.display = 'inherit';
        this.ctx.fill();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrap {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 452px;
  padding-left: 54px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: top center;
  .scratchCard-box {
    width: 269px;
    height: 114px;
    .award-box {
      width: 269px;
      height: 114px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      span{
        color: #cc162d;
        font-size: 14px;
        line-height: 114px;
      }
    }
    .canvas {
      position: relative;
      width: 100%;
      height: 100%;
    }
  }
}
</style>